import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M715.925665,1409.20256 C465.79765,1409.20256 262.832119,1207.42628 262.832119,959.559245 C262.832119,711.957107 467.318627,509.91593 717.713638,509.91593 L990.537375,509.91593 L990.537375,352.174918 L715.925665,352.174918 C379.45569,352.174918 105.174918,624.503057 105.174918,959.559245 C105.174918,1294.61319 379.456948,1566.94357 715.925665,1566.94357 L988.749401,1566.94357 L988.749401,1409.20256 L715.925665,1409.20256 Z M368.007037,959.559245 C368.007037,1149.20097 523.746245,1304.02764 715.925665,1304.02764 L1093.92432,1304.02764 L1093.92432,1672.11849 L715.925665,1672.11849 C321.537905,1672.11849 0,1352.86848 0,959.559245 C0,566.247679 321.536733,247 715.925665,247 L1095.71229,247 L1095.71229,615.090848 L717.713638,615.090848 C525.123781,615.090848 368.007037,770.328728 368.007037,959.559245 Z M1358.54441,603.995571 L1358.54441,854.756138 L742.745269,854.756138 C684.181187,854.756138 637.991051,900.960481 637.991051,959.559245 C637.991051,1018.15801 684.181187,1064.36235 742.745269,1064.36235 L1358.54441,1064.36235 L1358.54441,1315.12292 L1761.12212,959.559245 L1358.54441,603.995571 Z M1253.36949,370.779519 L1920,959.559245 L1253.36949,1548.33897 L1253.36949,1169.53727 L742.745269,1169.53727 C626.087442,1169.53727 532.816133,1076.23727 532.816133,959.559245 C532.816133,842.881218 626.087442,749.58122 742.745269,749.58122 L1253.36949,749.58122 L1253.36949,370.779519 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconCommonsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCommonsLine, _Component);

  var _super = _createSuper(IconCommonsLine);

  function IconCommonsLine() {
    _classCallCheck(this, IconCommonsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCommonsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCommons",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCommonsLine.displayName = "IconCommonsLine";
  return IconCommonsLine;
}(Component);

IconCommonsLine.glyphName = 'commons';
IconCommonsLine.variant = 'Line';
IconCommonsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCommonsLine;
export { IconCommonsLine };